import MainLayout from '@/Layouts/MainLayout';
import { Head, useForm, router } from '@inertiajs/react';
import LetterComponent from '@/Components/Letter';
import CommentList from '@/Components/CommentList';
import { useState } from 'react';

export default function Letter({ auth, letter, can_edit, is_bookmark, is_queue, is_tmobile, is_op }) {

    const { post } = useForm({})    

    const handleLetterHide = () => {

        axios.post(route('letter.hide', [letter.id]))
        .then(function (res) {

            if(res.data.success == true) {
                router.visit(route('letter.hidden', [letter.id]));
            }

        })        

    }

    const handleLetterShow = () => {

        axios.post(route('letter.show', [letter.id]))
        .then(function (res) {

            if(res.data.success == true) {
                router.visit(route('letter.shown', [letter.id]));
            }

        })        

    }

    const handleBookmarkAdd = () => {

        axios.post(route('bookmark.add', [letter.id]))
        .then(function (res) {

            if(res.data.success == true) {
                router.visit(route('letter.details', [letter.id]));
            }

        })        

    }

    const handleBookmarkRemove = () => {

        axios.post(route('bookmark.remove', [letter.id]))
        .then(function (res) {

            if(res.data.success == true) {
                router.visit(route('letter.details', [letter.id]));
            }

        })        

    }    

    const handleQueueAdd = () => {

        axios.post(route('queue.create', [letter.id]))
        .then(function (res) {

            if(res.data.success == true) {
                router.visit(route('queue.index'));
            } else {
                console.log("Failed to queue");
            }

        })        

    }    

    const handleQueueRemove = () => {

        axios.post(route('queue.remove', [letter.id]))
        .then(function (res) {

            if(res.data.success == true) {
                router.visit(route('queue.index'));
            } else {
                console.log("Failed to remove queue");
            }

        })        

    }    

    const handleLetterComments = () => {

        let comment_route = route('letter.disable_comments', [letter.id]);

        if(letter.disable_comments == true) {
            comment_route = route('letter.enable_comments', [letter.id])
        }

        axios.post(comment_route)
        .then(function (res) {

            if(res.data.success == true) {
                router.visit(route('letter.details', [letter.id]));
            }

        })        

    }    


    const handleReport = () => {

        router.post(route('report.index'), {id: letter.id, type: "letter"});

    }        

    return (
        <>
            <MainLayout auth={auth}>
                <Head title={`letter #${letter.id} - letters to crushes`} />
                <LetterComponent key={`letterHolder-${letter.id}`} letter={letter} level="0" />
                <div className="text-[9px] xs:text-[11px] flex flex-row my-[15px] flex-wrap justify-center gap-y-2">
                    {can_edit && (
                        <a href={route('letter.edit', letter.id)} className="text-pink mx-2 flex-0 no-underline border-b-pink border-b-[1px] hover:border-0">edit letter</a>
                    )}
                    {can_edit && (
                        letter.level > -1 ? (
                            <a onClick={handleLetterHide} className="text-pink mx-2 flex-0 no-underline border-b-pink border-b-[1px] hover:border-0">hide</a>
                        ) : (
                            <a onClick={handleLetterShow} className="text-pink mx-2 flex-0 no-underline border-b-pink border-b-[1px] hover:border-0">unhide</a>
                        )
                    )}
                    {can_edit && (
                        letter.disable_comments == false ? (
                            <a onClick={handleLetterComments} className="text-pink mx-2 flex-0 no-underline border-b-pink border-b-[1px] hover:border-0">disable comments</a>
                        ) : (
                            <a onClick={handleLetterComments} className="text-pink mx-2 flex-0 no-underline border-b-pink border-b-[1px] hover:border-0">enable comments</a>
                        )                        
                    )}
                    {auth?.user?.l > 0 && (

                        is_queue ? (
                            <a onClick={handleQueueRemove} className="text-pink mx-2 flex-0 no-underline border-b-pink border-b-[1px] hover:border-0">unqueue</a>
                        ) : (
                            <a onClick={handleQueueAdd} className="text-pink mx-2 flex-0 no-underline border-b-pink border-b-[1px] hover:border-0">queue</a>
                        )

                    )}
                    {auth?.user && (
                        is_bookmark ? (
                            <a onClick={handleBookmarkRemove} className="text-pink mx-2 flex-0 no-underline border-b-pink border-b-[1px] hover:border-0">unbookmark</a>
                        ) : (
                            <a onClick={handleBookmarkAdd} className="text-pink mx-2 flex-0 no-underline border-b-pink border-b-[1px] hover:border-0">bookmark</a>
                        )
                    )}
                    <a onClick={handleReport} className="text-pink mx-2 flex-0 no-underline border-b-pink border-b-[1px] hover:border-0">
                        <span className="pr-2">report</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor" className="inline text-pink w-[10px] mb-[2px]">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5" />
                        </svg>


                    </a>
                </div>
                {auth?.user?.l == 1 && (
                    <p className="text-center text-gray-300 text-[10px]">Posted by {letter.ip}</p>
                )}
                {auth?.user?.l == 2 && (
                    <p className="text-center text-gray-300 text-[10px]"><a href={`/ip-activity/${letter.ip}`}>Posted by {letter.ip}</a></p>
                )}

                <CommentList comments={letter.comments} user={auth.user} letter={letter} is_tmobile={is_tmobile} is_op={is_op}></CommentList>
            </MainLayout>
        </>
    );
}
